import React from 'react';
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useCardStyles = makeStyles((theme) => ({
  cardContent: {
    minHeight: '110px',
  },
  cardIcon: {
    marginRight: '1rem',
    fontSize: '1.5rem',
  },
  cardDescription: {
    marginTop: '2rem',
  },
}))

function Card (props) {
    const { iconClass, disabled, description, href, title } = props
    const classes = useCardStyles()
    return (
      <div className='col-sm-6 col-md-4'>
        <div className='panel panel-default'>
          <div className={clsx('panel-body text-center', classes.cardContent)}>
            <i className={clsx(iconClass, classes.cardIcon)} />
            <span>{title}</span>
            <p className={classes.cardDescription}>{description}</p>
          </div>
          <div className='panel-footer text-right'>
            <Link disabled={disabled} to={href} className='btn btn-default'>
              Go
            </Link>
          </div>
        </div>
      </div>
    )
}

function Manage (props) {
    return <div className="clearfix">
        <Card
            title="Assets"
            iconClass="far fa-image"
            description="Upload, edit, or delete your Miscellaneous Assets"
            href="/manage/media"
        />

        <Card
            title="Categories"
            iconClass=""
            description="Manage your Event Categories"
            href="/manage/categories"
        />

        <Card
            title="Encoders"
            iconClass="fa fa-terminal"
            description="Manage your Events' Source Encoders"
            href="/manage/encoders"
        />

        <Card
            title="Keywords"
            iconClass="fa fa-list-ul"
            description="Edit or Delete global Keywords"
            href="/manage/keywords"
        />

        <Card
            title="Locations"
            iconClass="fa fa-map-marker"
            description="Manage your Location Addresses and Contact information"
            href="/manage/locations"
        />

        <Card
          title="Channels"
          iconClass="fas fa-th-list x1"
          description="Manage your Embedded Channel Listings"
          href="manage/listing"
        />

        <Card
            title="Player"
            iconClass="fa fa-play"
            description="Manage your Embed Player and Layouts"
            href="/manage/player"
        />

        <Card
            title="Technicians"
            iconClass="fa fa-user"
            description="Manage the identity of your Video Technicians and view their upcoming schedules"
            href="/manage/technicians"
        />

        <Card
            title="Ad Campaigns"
            iconClass="fa fa-bullseye"
            description="Manage video advertisements"
            href="/manage/ads"
        />

        <Card
            title="OTT devices"
            iconClass="fa fa-tv"
            description="Manage OTT devices: Roku, Apple TV, Amazon Firestick"
            href="/manage/ott"
            disabled={props.disabled.ott}
        />
        
        <Card
            title="Transcript Vocab"
            iconClass="fa fa-book"
            description="Manage Transcription Vocabulary"
            href="/manage/vocab"
        />

    </div>;
}

export default Manage;
